import type {
  ApplyCanvasOperationsInput,
  ApplyCanvasOperationsOutput,
  CanvasDocument,
  OpenCanvasDocumentInput,
  StartCanvasAdVariationsInput,
  StartCanvasAdVariationsOutput,
} from "schemas/generated/bedrockApi/canvasDocuments";
import type { RequestFn } from "./request";

/**
 * Canvas sets are edited through their project coordinator: `open` returns the
 * live copy and its revision, `apply` sends frame-level operations built
 * against that revision. Other editors receive the same operations over
 * `client.projectCoordinator.onCanvasChanged`.
 */
export function createCanvasDocumentsClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    openCanvasDocument: (input: OpenCanvasDocumentInput) => {
      return request<CanvasDocument>({
        method: "POST",
        path: "/api/v1/canvas-documents/open",
        body: input,
      });
    },
    applyCanvasOperations: (input: ApplyCanvasOperationsInput) => {
      return request<ApplyCanvasOperationsOutput>({
        method: "POST",
        path: "/api/v1/canvas-documents/apply",
        body: input,
      });
    },
    /** Fills a set's output frames from its source frame on the server; progress lands in the set as it runs. */
    startAdVariations: (input: StartCanvasAdVariationsInput) => {
      return request<StartCanvasAdVariationsOutput>({
        method: "POST",
        path: "/api/v1/canvas-documents/ad-variations",
        body: input,
      });
    },
  };
}
